import { useApp } from '../app-context';
import { BanneredMenu } from '../components/BanneredMenu';
import { Claim } from '../components/ClaimsList';
import {
    TSPage,
    TSAccordion,
    TSClaimDetails,
    TSFileCard,
    TSExpense,
    TSClaimLink,
    isInFinishProgressClaim,
    isInEarlyProgressClaim
} from '../components/commons';
import './ClaimPage.scss';
import { DashService } from '../services/DashService';
import { useEffect } from "react";
import { useState } from 'react';

const ClaimPage = function ({ name, pageState, claim, claims }) {
    const [state, dispatcher] = useApp();
    const [claimData, setClaimData] = useState(null);
    const [linkedClaims, setLinkedClaims] = useState(null);
    const [attachedFiles, setAttachedFiles] = useState(null);
    const [sentToUserFiles, setSentToUserFiles] = useState(null);

    const handleOpenClaim = async (e) => {
        let data = await DashService.openClaim(state._token, claim?.pet.policyId);
        dispatcher({ action: 'showPage', params: { id: 'botClaim', props: { botScript: data.claimScript, botToken: data.claimSession } } })
    };

    const handleBack = () => {
        dispatcher({ action: "closePage", params: { id: "claim" } });
        dispatcher({ action: "showPage", params: { id: "main" } });
    }

    useEffect(async() => {
        const res = await DashService.getClaimData(state._token, claim?.id);
        setAttachedFiles(res?.userUploadedFiles || []);
        setSentToUserFiles(res?.sentToUserFiles);
        let linked = res?.claims;
        linked?.sort((a, b) => a.submittedAt === b.submittedAt ? a._id - b._id : a.submittedAt - b.submittedAt);

        setLinkedClaims(linked);
        let c = res?.claims?.filter(v => v._id === claim?.id)[0];
        let parent = res?.claims?.filter(v => !v.parentClaimId)[0];
        if (c) {
            c.claimId = parent?.claimId || c._id;
            c.policyId = res?.policy?.policyId && res?.policy?.policySuffix ? res?.policy?.policyId + "/" + res?.policy?.policySuffix : undefined;
        }
        setClaimData(c);
    }, [claim?.id]);

    if (!claimData) return <div>Loading...</div>;

    const handleLinkedClaimClick = (e, linkedClaim) => {
        e.preventDefault();
        dispatcher({ action: "closePage", params: { id: "main" } });
        dispatcher({ action: "showPage", params: { id: "claim", props: { claim: linkedClaim } } });
    };

    return (
        < TSPage name={name} pageState={pageState} className="fading" >
            <div className="ts-limiter">
                <BanneredMenu claimScreen={false}></BanneredMenu>
                <div className="mainContent">
                    <div className="top">
                        <button className="yellow menu-item" onClick={handleOpenClaim}>הגשת תביעה חדשה</button>
                        <a href="tel:*6558" className="dial-link tel menu-item"><img src="/img/tel-dark.svg" alt="tel" />*6558</a>
                        <h3 className="main-title">{"תביעה"}</h3>
                        <img src="/img/tracker/icon-back-arrow.svg" onClick={handleBack} style={{ cursor: "pointer" }} />
                    </div>
                    <div className="card">
                        <TSAccordion title="פרטי תביעה" uiParams={state.uiParams} forceToggle={true}>
                            <Claim claim={claim} key={"claim" + claim.id} />
                            <div className="white card">
                                <TSClaimDetails claimData={claimData} />
                            </div>
                        </TSAccordion>
                    </div>
                    {false && sentToUserFiles?.length > 0 && (
                    <div className="card">
                        <TSAccordion title="מסמכים ששלחנו אליך" forceToggle={true}>
                            {sentToUserFiles?.map(v => <TSFileCard key={v.id} file={v} />)}
                        </TSAccordion>
                    </div>
                    )}
                    {attachedFiles?.length > 0 && (
                    <div className="card">
                        <TSAccordion title="מסמכים שהוגשו" forceToggle={true}>
                            {attachedFiles?.map(v => <TSFileCard key={v.id} file={v} />)}
                        </TSAccordion>
                    </div>
                    )}
                    {(isInEarlyProgressClaim(claim) || isInFinishProgressClaim(claim)) && (
                    <div id="invoices" className="card">
                        <TSAccordion title={isInFinishProgressClaim(claim) ? "חשבוניות שנבדקו בתביעה" : "חשבוניות שנבדקות בתביעה"} forceToggle={true}>
                            {claimData.expenses?.map(v => <TSExpense key={v.id} expense={v} claim={claim} />)}
                        </TSAccordion>
                    </div>
                    )}
                    {linkedClaims?.length > 1 && (
                    <div className="card">
                        <TSAccordion title="תביעות קשורות" forceToggle={true}>
                            {
                                linkedClaims?.map(v => {
                                    return (
                                        <TSClaimLink key={v._id} claim={v} isSelected={v._id === claim.id} onClick={(e) => { handleLinkedClaimClick(e, {...v, id: v.id || v._id}) }} />
                                    )
                                })
                            }
                        </TSAccordion>
                    </div>
                    )}
                </div>
            </div>
        </TSPage >
    )
}

export { ClaimPage };